import _ from 'lodash'
import React from 'react'
import classnames from 'classnames/bind'
import Text from '../../../elementals/text'
import Icon from '../../../elementals/icon'
import styles from '../styles.scss'
import ListingBadge, { BADGE_MODE, CondensedBadge } from './base'

const cx = classnames.bind(styles)

export default class FullWidthBadge extends ListingBadge {
  render() {
    const {
      titleIcon,
      title,
      content,
      contentPositive,
      summary,
      condensedTitleIcon,
      condensedTitle,
    } = this.constructor

    const badgeContent = content || this.content
    const badgeSummary = summary || this.summary

    const elmId = _.snakeCase(title || summary)

    return this.props.mode === BADGE_MODE.CONDENSED ? (
      <CondensedBadge
        elmId={elmId}
        title={condensedTitle || title || summary}
        iconName={condensedTitleIcon || titleIcon}
      />
    ) : (
      <div
        className={cx('u-display-f', 'u-stretch', 'hoisted-badge')}
        data-elm-id={`${elmId}_container`}
      >
        <div>
          <Icon
            iconStyle='light'
            className={cx('hoisted-badge-icon')}
            name={titleIcon}
            data-elm-id={`${elmId}_icon`}
          />
        </div>
        <Text>
          <strong
            data-elm-id={`${elmId}_label`}
            className={cx(contentPositive ? 'color-success' : 'color-warning')}
          >
            {badgeSummary}:{' '}
          </strong>
          <span data-elm-id={`${elmId}_content`}>{badgeContent}</span>
        </Text>
      </div>
    )
  }
}
